import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import Papa from 'papaparse';
import Typography from '@mui/material/Typography';
import { downloadCsvFile } from '../../utils';
import OperationDetails from './OperationDetails';
import OperationVolumeConversion from './OperationVolumeConversion';

export default function OperationDetailDialog(props) {
  const { t } = useTranslation();
  const {
    operation, setOpen, open, organizationName,
  } = props;
  const [compartmentsCsv, setcompartmentsCsv] = React.useState('');

  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    function formatCompartmentsAndVolumesForCsv(op) {
      return op.compartmentsHeightsAndVolumes.map((comp) => ({
        operationId: op.id,
        [t('operation_csv_headers.tankNumber')]: op.tankNumber,
        [t('operation_csv_headers.compartment')]: comp.number,
        [t('operation_csv_headers.height')]: comp.height,
        [t('operation_csv_headers.volume')]: comp.volume,
        [t('operation_csv_headers.totalVolume')]: op.totalVolume,
        date: new Date(op.dateAndTime.toMillis()).toLocaleString(),
        [t('operation_csv_headers.transporter')]: `${op.transporterName}(${organizationName})`,
        [t('operation_csv_headers.certificateNumber')]: op.certificateNumber,
      }));
    }
    function setcompartments() {
      setcompartmentsCsv(
        Papa.unparse(formatCompartmentsAndVolumesForCsv(operation), {
          delimiter: ';',
        }),
      );
    }

    if (operation !== '') {
      setcompartments();
    }
  }, [operation, organizationName, t]);

  return (
    <Dialog
      maxWidth="md"
      fullWidth
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {t('tank_selection.tank')}
        :
        {operation.tankNumber}
      </DialogTitle>
      <DialogContent>
        <OperationDetails organizationName={organizationName} operation={operation} />
        {operation.volumeConversionResults
        && (<OperationVolumeConversion batchResults={operation.volumeConversionResults} />)}
        {operation.volumeConversionMethod
        && (
        <Typography component="span">
          {t('settings.volume_calculation_method')}
          {': '}
          {operation.volumeConversionMethod === 'traditional'
         && (t('settings.traditional_method'))}
          {operation.volumeConversionMethod !== 'traditional'
         && ('OIML-OIV')}
        </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={(e) => {
            downloadCsvFile('compartiments', compartmentsCsv);
          }}
        >
          {t('download')}
        </Button>
        <Button onClick={handleClose}>
          {t('close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
